// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__DCuOL","title":"styles_title__2C9hh","subtitle":"styles_subtitle__62Xbq","tags-wrapper":"styles_tags-wrapper__XHWyO","tag":"styles_tag__ajljh"};